import React from "react";

import Button from "../../../common/components/Button";
import Context from "../../../context/Context";
import FieldNames from "../../../aiim/datasets/FieldNames";
import HelpTip from "../../../components/common/HelpTip/HelpTip";
import { ModalController } from "../../../common/components/Modal";
import OfficePlan from "../../base/OfficePlan";
import ReservationManagers from "./ReservationManagers";
import Topic from "../../../context/Topic";
import TransactionGuard from "../../base/TransactionGuard";
import * as aiimUtil from "../../../aiim/util/aiimUtil";
import * as component from "../../../components/util/component";

import Form, { FormControl, FormControlLabel, FormHelperText } from "calcite-react/Form";
import ReactToggle from "react-toggle";
import TextField from "calcite-react/TextField";

import { TimePicker } from "antd";
import moment from "moment";

export default class AreaProperties extends React.Component {

  componentId;
  timeFormat;
  use12Hours;

  constructor(props) {
    super(props);
    this.componentId = component.nextId();
    const locale = Context.instance.lib.dojo.kernel.locale
    if (locale === "en" || locale === "en-us") {
      this.use12Hours = true
      this.timeFormat = "h:mm A"
    } else {
      this.use12Hours = false
      this.timeFormat = "H:mm"
    }

    const isHotel = (this.props.areaType === "hotel");
    let v, name = "", restricted = true;
    let maxBookingsPerPerson = null, maxDaysPerBooking = null, maxDaysInAdvance = null;
    let autoCancelMinutes, autoCancelMinutesAllDay, autoCancelMinutesAllDayTM = null;
    if (this.props.areaItem) {
      const attr = this.props.areaItem.attributes;
      name = aiimUtil.getAttributeValue(attr,FieldNames.AREA_NAME) || "";
      if (this.props.supportsRestricted) {
        v = aiimUtil.getAttributeValue(attr, FieldNames.AREAS_RESTRICTED);
        restricted = (v !== 0); // hotels are restricted unless RESTRICTED = 0
      }
      if (this.props.supportsBookingLimits) {
        const plan = Context.instance.spaceplanner.activePlan;
        const limits = plan.areasTable.getBookingLimits(this.props.areaItem);
        maxBookingsPerPerson = limits.maxBookingsPerPerson;
        maxDaysPerBooking = limits.maxDaysPerBooking;
        maxDaysInAdvance = limits.maxDaysInAdvance;
        autoCancelMinutes = limits.autoCancelMinutes;
        autoCancelMinutesAllDay = limits.autoCancelMinutesAllDay;
      }
    } else {
      if (isHotel && this.props.supportsBookingLimits) {
        const limits = Context.instance.session.newHotelConfig;
        if (limits) {
          maxBookingsPerPerson = limits.maxBookingsPerPerson;
          maxDaysPerBooking = limits.maxDaysPerBooking;
          maxDaysInAdvance = limits.maxDaysInAdvance;
          autoCancelMinutes = limits.autoCancelMinutes;
          autoCancelMinutesAllDay = limits.autoCancelMinutesAllDay;
        }
      }
    }

    if (typeof autoCancelMinutesAllDay === "number" && autoCancelMinutesAllDay >= 1) {
      autoCancelMinutesAllDayTM = moment().startOf("day").add(autoCancelMinutesAllDay,"minutes");
    }

    this.state = component.newState({
      activePage: 1,
      name: name,
      nameError: null,
      restricted: restricted,
      maxBookingsPerPerson: maxBookingsPerPerson,
      maxDaysPerBooking: maxDaysPerBooking,
      maxDaysInAdvance: maxDaysInAdvance,
      autoCancelMinutes: autoCancelMinutes,
      autoCancelMinutesAllDay: autoCancelMinutesAllDay,
      autoCancelMinutesAllDayTM: autoCancelMinutesAllDayTM
    });

    if (this.props.actionBarInfo) {
      this.props.actionBarInfo.onPageChanged = num => {
        this.setState({activePage: num});
      }
      this.props.actionBarInfo.canStepNext = () => {
        return !this.state.nameError
      }
    }

  }

  componentDidMount() {}

  componentDidUpdate() {
    const chk = (v) => {
      if (typeof v !== "number" || v < 1) return null;
      v = Math.floor(v);
      return v;
    }
    if (this.props.onChange) {
      let data = {
        name: this.state.name.trim()
      }
      if (this.props.supportsRestricted) {
        data.restricted = this.state.restricted;
      }
      if (this.props.supportsBookingLimits) {
        data.config = {
          maxBookingsPerPerson: chk(this.state.maxBookingsPerPerson),
          maxDaysPerBooking: chk(this.state.maxDaysPerBooking),
          maxDaysInAdvance: chk(this.state.maxDaysInAdvance)
          // autoCancelMinutes: chk(this.state.autoCancelMinutes),
          // autoCancelMinutesAllDay: chk(this.state.autoCancelMinutesAllDay)
        };
      }
      this.props.onChange(data);
    }
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  checkName(name) {
    const i18n = Context.instance.i18n;
    const v = name.trim();
    if (v.length === 0) {
      return i18n.spaceplanner.areaProperties.emptyAreaName;
    } else {
      const invalid = AreaProperties.isInvalidPattern(name);
      if (invalid) {
        return i18n.spaceplanner.areaProperties.invalidAreaName;
      }
    }
    return null;
  }

  render() {
    const isNew = !this.props.areaItem;
    const isHotel = (this.props.areaType === "hotel");
    const supportsRestricted = isHotel && !!this.props.supportsRestricted;
    const supportsBookingLimits = isHotel && !!this.props.supportsBookingLimits;
    const supportsAreaRoles = isHotel && OfficePlan.getActive().hasAreaRoles();
    const actionBarInfo = this.props.actionBarInfo;
    let cls = "i--form";
    if (actionBarInfo && actionBarInfo.isMultiPage) {
      cls += " i-pages i--active-page-"+this.state.activePage;
    }

    return (
      <Form className={cls}>
        <div className="i-flex-columns i--page-1">
          {this.renderAreaName()}
          {supportsRestricted && this.renderRestricted()}
          {isNew && supportsAreaRoles && this.renderAreaManagers()}
        </div>
        <div className="i-flex-columns i--page-2">
          {supportsBookingLimits && this.renderBookingLimits()}
        </div>
      </Form>
    );
  }

  renderAreaManagers() {
    return (
      <ReservationManagers
        onRoleDataUpdated={this.props.onAreaManagersUpdated} />
    )
  }

  renderAreaName() {
    const i18n = Context.instance.i18n;
    const id = this.componentId;
    const errmsg = this.state.nameError;
    return (
      <FormControl horizontal={false}>
        <FormControlLabel
          id={id + "-name-label"}
          htmlFor="name"
          className="i--form-label">
          <span className="i--required">
            {i18n.spaceplanner.areaProperties.name}
          </span>
        </FormControlLabel>
        <TextField
          id={id + "-name"}
          name="name"
          autoFocus
          fullWidth={true}
          value={this.state.name}
          error={!!errmsg}
          onBlur={evt => {
            this.setState({
              nameError: this.checkName(this.state.name)
            });
          }}
          onChange={evt => {
            let nameError = this.checkName(evt.target.value);
            this.setState({
              name: evt.target.value,
              nameError: nameError
            });
          }}
        />
        {errmsg && <FormHelperText error>{errmsg}</FormHelperText>}
      </FormControl>
    );
  }

  renderBookingLimits() {
    const i18n = Context.instance.i18n;
    let showHR = true;
    if (this.props.actionBarInfo && this.props.actionBarInfo.isMultiPage) {
      showHR = false;
    }
    return (
      <>
        {showHR && <hr style={{width: "100%", marginBottom: "1.9375rem"}}/>}
        <FormControl>
          <FormControlLabel style={{fontWeight: 600}}>
            {i18n.meetingRooms.schedule.options}
          </FormControlLabel>
        </FormControl>
        {this.renderMaxBookingsPerPerson()}
        {this.renderMaxDaysPerBooking()}
        {this.renderMaxDaysInAdvance()}
        {/*this.renderAutoCancelMinutes()*/}
        {/*this.renderAutoCancelMinutesAllDay()*/}
      </>
    )
  }

  renderLimit(options) {
    const i18n = Context.instance.i18n;
    let value = options.value;
    if (value === -1 || value === null) value = "";
    const isAutoCancelMinutesAllDay = (options.key === "autoCancelMinutesAllDay");
    let autoCancelMinutesAllDayTM = this.state.autoCancelMinutesAllDayTM;
    if (isAutoCancelMinutesAllDay) {
      let v = this.state.autoCancelMinutesAllDay;
      if (typeof v !== "number" || v < 1) autoCancelMinutesAllDayTM = null;
    }

    let maxBkgsPersonStr = null;
    if (options && options.key === "maxBookingsPerPerson") maxBkgsPersonStr = i18n.spaceplanner.areaProperties.maxBookingsPerPersonSubtitle;


    return (
      <FormControl horizontal={false}>
        <div className="i-flex-between" style={{width: "100%"}}>
          <FormControlLabel>{options.label}</FormControlLabel>
          <span className={"i-toggle-spaceplanner"}>
            <ReactToggle id={this.componentId+"_"+options.key}
              icons={false}
              checked={options.checked}
              onChange={evt => {
                options.onToggle(!!evt.target.checked)
              }}
            />
          </span>
        </div>
        {maxBkgsPersonStr && (<div style={{fontStyle: "italic", color: "#808080", marginTop: "-0.3rem"}}>{maxBkgsPersonStr}</div>)}
        <div style={{width: "15rem", display: "block"}}>
          {!isAutoCancelMinutesAllDay &&
            <div className="i-flex-row-center">
              <TextField
                fullWidth
                type="number"
                disabled={!options.checked}
                min={options.min}
                max={options.max}
                step="1"
                value={value}
                onChange={evt => {
                  let v = evt.target.value;
                  if (!v) v = -1;
                  else v = Number(v);
                  options.onValueChange(v)
                }}
              />
              {options.helpTip && <HelpTip text={options.helpTip} />}
            </div>
          }
          {isAutoCancelMinutesAllDay &&
            <div className="i-flex-row-center" style={{marginTop: "0.25rem"}}>
              <TimePicker
                disabled={!options.checked}
                use12Hours={this.use12Hours}
                format={this.timeFormat}
                minuteStep={5}
                showNow={false}
                inputReadOnly={true}
                value={autoCancelMinutesAllDayTM}
                placeholder={i18n.spaceplanner.areaProperties.selectTime}
                placement="bottomLeft"
                popupClassName="i-time-picker-dropdown"
                onChange={(time, timeString) => {
                  if (time) {
                    const dtStart = moment(time).startOf("day").toDate();
                    const duration = moment.duration(time.diff(moment(dtStart)));
                    let minutes = Math.floor(duration.asMinutes());
                    if (minutes < 1) minutes = null;
                    this.setState({
                      autoCancelMinutesAllDay: minutes,
                      autoCancelMinutesAllDayTM: time
                    })
                  }
                }}
                onOpenChange={(open) => {
                  if (open) {
                    const preventScroll = () => {
                      const timeColumns = document.getElementsByClassName("ant-picker-time-panel-column")
                      for (let i = 0; i < timeColumns.length; i++) {
                        const text = timeColumns[i].firstChild.firstChild.innerText
                        if (text === "AM" || text === "PM") {
                          timeColumns[i].style.overflowY = "visible"
                        }
                      }
                    }
                    setTimeout(preventScroll, 100)
                  }
                }}
              />
              {options.helpTip && <HelpTip text={options.helpTip} />}
            </div>
          }
        </div>
      </FormControl>
    );
  }

  renderLimitProp(propName) {
    const i18n = Context.instance.i18n;
    const lbl = i18n.spaceplanner.areaProperties[propName];
    const helpTip = i18n.spaceplanner.areaProperties[propName+"Tip"];
    const value = this.state[propName];
    const checked = (typeof value === "number")
    return this.renderLimit({
      label: lbl,
      helpTip: helpTip,
      key: propName,
      checked: checked,
      min: 1,
      max: 1000000,
      value: value,
      onToggle: b => {
        const v = b ? -1: null;
        this.setState({[propName]: v})
      },
      onValueChange: v => {
        this.setState({[propName]: v})
      }
    })
  }

  renderAutoCancelMinutes() {
    return this.renderLimitProp("autoCancelMinutes");
  }

  renderAutoCancelMinutesAllDay() {
    return this.renderLimitProp("autoCancelMinutesAllDay");
  }

  renderMaxBookingsPerPerson() {
    return this.renderLimitProp("maxBookingsPerPerson");
  }

  renderMaxDaysPerBooking() {
    return this.renderLimitProp("maxDaysPerBooking");
  }

  renderMaxDaysInAdvance() {
    return this.renderLimitProp("maxDaysInAdvance");
  }

  renderRestricted() {
    const i18n = Context.instance.i18n;
    const lbl = i18n.spaceplanner.areaProperties.restricted;
    return (
      <FormControl horizontal={false}>
        <div className="i-flex-between" style={{width: "100%"}}>
          <FormControlLabel>{lbl}</FormControlLabel>
          <span className={"i-toggle-spaceplanner"}>
            <ReactToggle id={this.componentId+"_restricted"}
              icons={false}
              checked={!!this.state.restricted}
              onChange={evt => {
                this.setState({restricted: !!evt.target.checked});
              }}
            />
          </span>
        </div>
      </FormControl>
    )
  }

  static async checkDuplicateName(name,areaType,origAreaName) {
    const i18n = Context.instance.i18n;
    const plan = Context.instance.spaceplanner.activePlan;
    const result = {ok: true};
    let areas, dupTitle, dupMsg;

    if (areaType === "hotel") {
      areas = await plan.queryHotelAreas();
      dupTitle = i18n.spaceplanner.areaProperties.createDuplicateHotelName;
      dupMsg = i18n.spaceplanner.areaProperties.duplicateHotelNamePrompt;
    } else {
      areas = await plan.queryHotDeskAreas();
      dupTitle = i18n.spaceplanner.areaProperties.createDuplicateHotdeskName;
      dupMsg = i18n.spaceplanner.areaProperties.createDuplicateHotdeskNamePrompt;
    }

    if (areas) {
      const lc = name.toLowerCase();
      const lcOrig = origAreaName.toLowerCase();
      const hasDup = areas.some(f => {
        const v = aiimUtil.getAttributeValue(f.attributes,FieldNames.AREA_NAME);
        if (typeof v === "string" && lc === v.toLowerCase()) {
          if (lcOrig && lc === lcOrig) return false;
          return true;
        }
        return false;
      })
      if (hasDup) {
        result.ok = false;
        const options = {
          title: dupTitle,
          message: dupMsg,
          okLabel: i18n.general.ok
        };
        const r = await ModalController.confirm(options);
        if (r.ok) result.ok = true;
      }
    }
    return result;
  }

  static isInvalidPattern(name) {
    const charPattern=/<[a-zA-Z0-9` !@#$%^&*()_+\-=\[\]{};':"\\|,.\/?~]*>/g;
    return name.match(charPattern);
  }

  static actionBar(options) {
    let info;
    info = {
      page: 1,
      isMultiPage: options.isMultiPage,
      content: null,
      okButton: null,
      okButtonClicked: null,
      cancelButton: null,
      cancelButtonClicked: null,
      backButton: null,
      backButtonClicked: null,
      nextButton: null,
      nextButtonClicked: null,
      canStepNext: null,
      onPageChanged: null,
      setPage: num => {
        info.page = num;
        if (info.backButton) {
          if (info.page === 1) info.backButton.disable();
          else info.backButton.enable();
        }
        if (info.nextButton) {
          if (info.page > 1) info.nextButton.disable();
          else info.nextButton.enable();
        }
        if (info.onPageChanged) info.onPageChanged(num)
      }
    }
    const i18n = Context.instance.i18n;
    let btnOK = (
      <Button key="modal-assign" className="i-ok-button" gapRight
        onClick={evt => {
          if (info.okButtonClicked) info.okButtonClicked(evt)
        }}
        _onMount={obj => {
          info.okButton = obj
        }}>
        {options.okLabel || i18n.general.ok}
      </Button>
    )
    let btnCancel = (
      <Button key="modal-cancel" className="i-cancel-button" clear gapRight
        onClick={evt => {
          if (info.cancelButtonClicked) info.cancelButtonClicked(evt)
        }}
        _onMount={obj => {
          info.cancelButton = obj
        }}>
        {i18n.general.cancel}
      </Button>
    )
    let btnBack = info.isMultiPage && (
      <Button key="modal-back" clear gapRight disabled
        onClick={evt => {
          info.setPage(1);
          if (info.backButtonClicked) info.backButtonClicked(evt)
        }}
        _onMount={obj => {
          info.backButton = obj
        }}>
        {i18n.general.back}
      </Button>
    )
    let btnNext = info.isMultiPage && (
      <Button key="modal-next" clear gapRight
        onClick={evt => {
          if (info.canStepNext && !info.canStepNext()) return;
          info.setPage(2);
          if (info.nextButtonClicked) info.nextButtonClicked(evt)
        }}
        _onMount={obj => {
          info.nextButton = obj
        }}>
        {i18n.general.next}
      </Button>
    )
    info.content = (
      <div className="i-flex-between" style={{width: "100%"}}>
        <div>
          {btnBack}
          {btnNext}
        </div>
        <div>
          {btnCancel}
          {btnOK}
        </div>
      </div>
    )
    return info;
  }

  static showModal(props) {
    let controller, adding = false;
    let areaName = "", invalidName, data, roleData;
    const i18n = Context.instance.i18n;
    const plan = Context.instance.spaceplanner.activePlan;
    const areasTable = plan && plan.areasTable;
    const areaType = props.areaType;
    const isNew = !props.areaItem;
    const isHotel = (props.areaType === "hotel");
    const supportsRestricted = isHotel && !!plan.areasTable.getRestrictedField();
    const supportsBookingLimits = isHotel && !!plan.supportsBookingLimits();
    const supportsAreaRoles = isHotel && plan.hasAreaRoles();
    const isMultiPage = isNew && isHotel && supportsAreaRoles && supportsBookingLimits;
    const hasAreaRoles = plan.hasAreaRoles();
    if (props.areaItem) {
      areaName = aiimUtil.getAttributeValue(props.areaItem.attributes,FieldNames.AREA_NAME) || "";
      invalidName = AreaProperties.isInvalidPattern(areaName);
    }
    const origAreaName = areaName;

    const onChange = obj => {
      areaName = obj.name.trim();
      invalidName = AreaProperties.isInvalidPattern(areaName);
      data = obj;
    };

    const onOK = async () => {
      let ok = false;
      if (!adding && areaName.length > 0 && !invalidName) {
        try {
          const r = await AreaProperties.checkDuplicateName(areaName,areaType,origAreaName);
          ok  = !!r.ok;
        } catch(ex) {
          console.error(ex);
          Topic.publishErrorAccessingData();
        }
      }
      if (ok) {
        save();
      }
    }

    const save = () => {
      if (!adding && areaName.length > 0 && !invalidName) {
        if (controller) controller.close();
        const guard = new TransactionGuard({force: true});
        adding = true;
        Promise.resolve().then(() => {
          if (hasAreaRoles) {
            let areaRolesTable = OfficePlan.getActive().areaRolesTable;
            return areaRolesTable.prepUsernames(roleData);
          }
        }).then (() => {
          if (!data) data = {};
          if (roleData) data.roleData = roleData;
          const config = data.config;
          if (config && typeof config !== "string") {
            data.config = JSON.stringify(config);
          }
          if (isNew) {
            Context.instance.session.newHotelConfig = config;
            return areasTable.addArea(areaName,areaType,data);
          } else {
            return areasTable.updateArea(props.areaItem,areaName,data);
          }
        }).then (() => {
          guard.close();
          Topic.publish(Topic.PlanModified, {
            action: OfficePlan.Action_AssignmentsUpdated
          });
        }).catch(error => {
          guard.close();
          console.error("Error adding area", error);
          Topic.publishErrorUpdatingData(error.submessage);
        });
      }
    };

    const onAreaManagersUpdated = (data) => {
      roleData = data;
    }

    let actionBarInfo = AreaProperties.actionBar({
      isMultiPage: isMultiPage,
      okLabel: isNew ? i18n.spaceplanner.areaProperties.add : i18n.spaceplanner.areaProperties.save
    });
    let actionBarContent = actionBarInfo.content;
    actionBarInfo.okButtonClicked = () => {
      onOK();
    }
    actionBarInfo.cancelButtonClicked = () => {
      if (controller) controller.close();
    }

    const modalProps = {
      dialogStyle: { width: "35vw" },
      title: props.caption,
      showOKCancel: false,
      actionBarContent: actionBarContent
    };

    if (plan && plan.wasOpened && plan.isAreasTableValid() && areasTable) {
      const content = (
        <AreaProperties {...props}
          actionBarInfo={actionBarInfo}
          onChange={onChange}
          supportsRestricted={supportsRestricted}
          supportsBookingLimits={supportsBookingLimits}
          onAreaManagersUpdated={onAreaManagersUpdated} />
      );
      controller = new ModalController({});
      controller.show(modalProps, content);
    }
  }
}
